var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-9 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete element") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M11.923,75.611A8.894,8.894,0,0,0,20.77,84.5H56.157A8.894,8.894,0,0,0,65,75.611V22.278H11.923ZM22.8,43.967,29.042,37.7l9.422,9.422L47.841,37.7l6.237,6.267L44.7,53.389l9.377,9.422-6.237,6.267-9.377-9.422-9.377,9.422-6.237-6.267,9.377-9.422ZM53.945,8.944,49.522,4.5H27.4L22.982,8.944H7.5v8.889H69.427V8.944Z",
    transform: "translate(-7.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinDelete);
export default __webpack_public_path__ + "static/media/binDelete.ed08898c41a6836596b72beae5dec612.svg";
export { ForwardRef as ReactComponent };